import classNames from "classnames";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/student/Button";
import { Modal } from "@components/student/Modal";
import CloseIcon from "@static/svg/close.svg";
import * as s from "./LevelNotification.sss";
import { SelectedCity } from "@/constants";
export const LevelNotification = ({ agreeLevel, cancelAddition, title, warningDescription, citiesInput, }) => {
    var _a, _b;
    const { t } = useTranslation();
    const [isOpenSelect, setIsOpenSelect] = React.useState(false);
    const [selectedCity, setSelectedCity] = React.useState({
        id: citiesInput && citiesInput.length > 0
            ? (_a = citiesInput[0]) === null || _a === void 0 ? void 0 : _a.id : SelectedCity(true),
        title: citiesInput && citiesInput.length > 0
            ? (_b = citiesInput[0]) === null || _b === void 0 ? void 0 : _b.title : SelectedCity(),
    });
    React.useEffect(() => {
        var _a;
        citiesInput
            ? localStorage.setItem("cityModal", true.toString())
            : localStorage.removeItem("cityModal");
        localStorage.setItem("cityId", ((_a = selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.id) === null || _a === void 0 ? void 0 : _a.toString()) || "");
        localStorage.setItem("cityName", (selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.title) || "");
    }, [selectedCity, citiesInput]);
    const toggleSelect = () => {
        setIsOpenSelect(prevState => !prevState);
    };
    const handleChangeCity = (cityId) => {
        const currentLocation = citiesInput.find(({ id }) => id === cityId);
        setSelectedCity(currentLocation);
    };
    const handleAgree = () => {
        agreeLevel(true);
        citiesInput && window.location.reload();
    };
    const handleDeny = () => {
        !warningDescription && agreeLevel(false);
        cancelAddition();
    };
    return (React.createElement(Modal, { className: classNames(s.root, { [s.inputCity]: citiesInput }), theme: "white", isOpen: true },
        React.createElement("div", { className: s.close },
            React.createElement(CloseIcon, { className: s.closeIcon, onClick: handleDeny })),
        React.createElement("div", { className: s.levelNotification },
            React.createElement("div", { className: s.content },
                React.createElement("h2", { className: s.titleHeader }, title || t("student~Ви впевнені?")),
                React.createElement("div", { className: s.description }, warningDescription ||
                    (!citiesInput && (React.createElement(React.Fragment, null,
                        React.createElement("p", null, t("student~Ви впевнені? Новачкам рекомендується вибирати рівень не вище Start+")),
                        React.createElement("br", null),
                        React.createElement("p", null, t("student~Рівень Start+ спеціально розроблений для тих, хто лише починає свій шлях у цій сфері. Він передбачає поступове ознайомлення з основами, що дозволяє уникнути перевантаження інформацією та забезпечує краще засвоєння матеріалу. Вибір вищих рівнів може призвести до труднощів у розумінні та засвоєнні матеріалу, що може знизити мотивацію до навчання.")))))),
                citiesInput && (React.createElement("div", { className: s.cityInput },
                    React.createElement("div", { className: s.selectWrapper, onClick: toggleSelect },
                        React.createElement("div", { className: `${s.inputBlock} ${isOpenSelect ? s.openArrow : ""}` },
                            React.createElement("label", { htmlFor: "city", id: "cityLabel", className: s.cityLabel }, "\u041C\u0456\u0441\u0442\u043E"),
                            React.createElement("input", { type: "text", id: "city", className: s.citySelect, value: selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.title })),
                        React.createElement("ul", { className: `${s.cityList} ${isOpenSelect ? s.open : s.closed}` }, citiesInput.map(city => (React.createElement("li", { key: city.id, onClick: () => handleChangeCity(city.id) },
                            city.title,
                            " ",
                            (selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.id) === city.id && "✓")))))))),
            React.createElement("div", { className: s.levelNotificationButtons },
                React.createElement("div", { className: citiesInput && s.cityChoiceContainer },
                    React.createElement(Button, { onClick: handleAgree, theme: citiesInput ? "primaryOrange" : "secondaryOrange", className: s.agreeButton + (citiesInput && ` ${s.cityChoice}`), id: "levelNotification" }, !citiesInput
                        ? t("student~Так, підтверджую")
                        : t("student~Вибрати"))),
                !citiesInput && (React.createElement("div", null,
                    React.createElement(Button, { onClick: handleDeny, theme: "primaryPurple", className: s.negativeButton, id: "levelNotification" }, t("student~Ні, вибрати інший рівень"))))))));
};
